import { render, staticRenderFns } from "./RuleDetail.vue?vue&type=template&id=28b8c55e&scoped=true"
import script from "./RuleDetail.vue?vue&type=script&lang=js"
export * from "./RuleDetail.vue?vue&type=script&lang=js"
import style0 from "./RuleDetail.vue?vue&type=style&index=0&id=28b8c55e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8c55e",
  null
  
)

export default component.exports